import type { PageContext } from "vike/types";
import type { Data } from "./+data";
import { categoryPageTitle } from "@/lib/seo";

// C4: single <title>/og:title owner (vike-react renders both from this).
// Same builder as +Head.tsx's twitter:title — never diverge.
export default function title(pageContext: PageContext): string | null {
  const data = pageContext.data as Data | undefined;
  if (!data?.category) return null;
  return categoryPageTitle(
    data.category,
    data.insights?.storeCount,
    data.insights?.reviewCount
  );
}
